<div
  class="calculator-layout"
  id="calculatorLayout"
  [class.drawer-opened-background]="
    calculationResponse && calculationDrawerOpened
  "
>
  <!-- Main Content Area (60%) -->
  <div class="main-content">
    <div style="margin-top: 30px">
      <span class="details-headline">Details</span>
    </div>

    <app-calculator-general-information
      #generalInformationComponent
      [generalInformation]="generalInformation"
      (onValueChanged)="generalInformationChanged($event)"
    >
    </app-calculator-general-information>

    <app-calculator-job-specification
      #jobSpecificationComponent
      [class.component-disabled]="!hasPublisherSelected()"
      [selectedPublisher]="generalInformation?.publisher"
      [jobSpecification]="jobSpecification"
      (onValueChanged)="jobSpecificationChanged($event)"
      (resetOverviewValues)="resetOverviewValues()"
    >
    </app-calculator-job-specification>

    <app-calculator-paper-specification
      #paperSpecificationComponent
      [class.component-disabled]="!hasProductSelected()"
      [selectedPublisherId]="generalInformation?.publisher?.id"
      [selectedClassification]="jobSpecification.product"
      [printedEndsheetActive]="printedEndsheetActive"
      [paperSpecification]="paperSpecification"
      (summaryUpdate)="addToPaperSpecSummary($event)"
      (onValueChanged)="paperSpecificationChanged($event)"
    >
    </app-calculator-paper-specification>

    <app-calculator-casetype-specification
      #caseTypeSpecificationComponent
      [class.component-hidden]="
        this.selectedProductClassification.includes('SOFTCOVER')
      "
      [class.component-disabled]="!hasProductSelected()"
      [selectedPublisherId]="generalInformation?.publisher?.id"
      [selectedClassification]="jobSpecification.product"
      [selectedInitialReprint]="selectedInitialReprint"
      [caseTypeSpecification]="caseTypeSpecification"
      (summaryUpdate)="addToCaseTypeSummary($event)"
      (onValueChanged)="caseTypeSpecificationChanged($event)"
    >
    </app-calculator-casetype-specification>
    <app-calculator-component-specification
      #componentSpecificationComponent
      [class.component-hidden]="!isSelectedProductWithComponents()"
      [class.component-disabled]="!hasProductSelected()"
      [selectedPublisherId]="generalInformation?.publisher?.id"
      [selectedClassification]="jobSpecification.product"
      [components]="calculatorComponents"
      (summaryUpdate)="addToComponentSummary($event)"
      (printedEndsheetStatusChange)="onPrintedEndsheetStatusChange($event)"
      (onValueChanged)="calculatorComponentsChanged($event)"
    >
    </app-calculator-component-specification>
    <app-calculator-prepress
      #prePressComponent
      [class.component-disabled]="!hasProductSelected()"
      [selectedInitialReprint]="selectedInitialReprint"
      [selectedPublisherId]="generalInformation?.publisher?.id"
      [selectedClassification]="jobSpecification.product"
      [prepressEnabled]="shouldShowPrepress()"
      [showToggleButton]="!isInitialSelected()"
      [prePressSpecification]="prePressSpecification"
      (summaryUpdate)="addToPrepressSummary($event)"
      (togglePrepress)="togglePrepress()"
      (onValueChanged)="prePressSpecificationChanged($event)"
    ></app-calculator-prepress>
    <app-calculator-bindery
      #binderyComponent
      [class.component-disabled]="!hasProductSelected()"
      [selectedPublisherId]="generalInformation?.publisher?.id"
      [selectedClassification]="jobSpecification.product"
      [binderySpecification]="binderySpecification"
      (summaryUpdate)="addToBinderySummary($event)"
      (onValueChanged)="binderySpecificationChanged($event)"
    ></app-calculator-bindery>
  </div>

  <!-- Fixed Sidebar (40%) -->
  <div class="sidebar">
    <app-calculator-summary
      #summaryComponent
      style="display: flex; width: 100%"
      [class.no-publisher-or-product-selected]="!hasProductSelected()"
      [summaryItems]="currentSummaryItems"
      [publisher]="generalInformation?.publisher"
    ></app-calculator-summary>
  </div>
</div>
<div
  class="form-buttons-container"
  id="formButtonsContainer"
  [class.open-drawer-width]="calculationResponse && calculationDrawerOpened"
  style="margin-bottom: -20px"
>
  <div
    class="form-buttons"
    [class.close-button]="calculationResponse && calculationDrawerOpened"
  >
    <dx-button
      [text]="formatMessage('calculator.button.calculate')"
      (onClick)="calculate($event)"
      [useSubmitBehavior]="true"
      [type]="calculateButtonType"
      [stylingMode]="calculateButtonStylingMode"
      class="calculate-button"
    >
    </dx-button>
  </div>
  <ng-container *ngIf="calculationDrawerOpened">
    <div class="response-drawer-container">
      <span class="calculation-headline">Calculation</span>
      <div class="response-table-container">
        <app-calculator-us-price-table
          [calculationResponse]="calculationResponse"
          [calculationTableConfig]="calculationTableConfig"
          [quantities]="quantities"
          [responseAncillaryGroupTypes]="responseAncillaryGroupTypes"
          [paperWeightData]="paperWeightData"
        ></app-calculator-us-price-table>
      </div>
    </div>
    <div class="form-buttons-container" id="pdfButtonContainer">
      <div class="form-buttons">
        <dx-button
          [disabled]="true"
          text="Download PDF"
          (onClick)="downloadPdf()"
          type="default"
          class="download-button"
          icon="download"
        >
        </dx-button>
      </div>
    </div>
  </ng-container>
</div>

<dx-toast
  [(visible)]="showToast"
  type="error"
  [message]="toastMessage"
  [displayTime]="toastDisplayTime"
></dx-toast>

